import { ADMIN_SUB_PAGES } from '@/app/(app)/admin/nav';
import { PageMain } from '@/app/(app)/page-main';
import { Link } from '@/components/link';

export function AdminLinksPage() {
  return (
    <PageMain title='Admin'>
      <div className='grid gap-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'>
        {ADMIN_SUB_PAGES.map((item) => (
          <Link
            href={item.url}
            key={item.title}
            className='flex flex-col space-y-2 rounded-lg border bg-background p-4 hover:border-primary'
          >
            <div className='flex flex-col gap-1'>
              <div className='flex items-center gap-2'>
                <item.icon className='size-4 shrink-0 text-muted-foreground' />
                <div className='font-semibold tracking-tight'>{item.title}</div>
              </div>
              <div className='text-sm text-muted-foreground'>{item.description}</div>
            </div>
          </Link>
        ))}
      </div>
    </PageMain>
  );
}
